import { APPLICATION_NAME } from '../../constants';
import { ENVIRONMENT } from '../../environment';
import { selectors as current } from '../current';

// Exporting for use with tests
export const APPLICATION_ANALYTICS = {
  // Not all of these are technically coming form the store,
  // though they might in the future, it probably still
  // makes sense to keep them here.
  Application: APPLICATION_NAME,
  Environment: ENVIRONMENT.name,
  'User Agent': window.navigator.userAgent,
};

export function staticProperties(state) {
  let properties = {
    ...APPLICATION_ANALYTICS,
    ...getCompanyAnalytics(state),
  };

  if (current.siteConfig().hasDivision(state)) {
    properties = {
      ...properties,
      ...getDivisionAnalytics(state),
    };
  }

  return properties;
}

export function getCompanyAnalytics(state) {
  const company = current.siteConfig().company(state);
  return company ? mapCompanyPropsToAnalytics(company) : {};
}

export function getDivisionAnalytics(state) {
  const division = current.siteConfig().division(state);
  return division ? mapDivisionPropsToAnalytics(division) : {};
}

function mapCompanyPropsToAnalytics(company) {
  return {
    Automated: company.automated,
    'Entity Status': company.status,
    Channel: company.channel,
    'Company ID': company.id,
    'Company Name': company.name,
    'Company Code': company.code,
  };
}

function mapDivisionPropsToAnalytics(division) {
  return {
    'Division Id': division.id,
    'Division Name': division.name,
  };
}
